import IconButton from '../../components/UI/IconButton/IconButton';
import Button from '../../new_arch/components/Button/Button';

import './UnsupportedFileFormatsPopup.scss';

type UnsupportedFileFormatsPopupProps = {
	unsupportedFormats: string[],
	onCancel: () => void,
	onConfirm: () => void
	forAssetRound: boolean,
}

const UnsupportedFileFormatsPopup = ( {
	unsupportedFormats, forAssetRound = false, onCancel, onConfirm
}: UnsupportedFileFormatsPopupProps ) => {
	const message = forAssetRound
		? 'Sorry, the item you\'re trying to upload is not supported as a new round for this asset. Please change it and try again.'
		: 'Sorry, the items you\'re trying to upload contain one or more unsupported formats. Please change them and try again.';

	return (
		<div className="UnsupportedFileFormatsPopup">
			<div className="dialog">
				<IconButton
					icon="clear"
					buttonClassName="close-icon"
					onClick={onCancel}
					size={24}
					testID="close-icon"
				/>
				<h4>Unsupported File Format{unsupportedFormats.length > 1 ? 's' : ''}</h4>
				<div className="description-container">
					<p className="description">{message}</p>
					<div className="unsupported-formats-container">
						<p className="title">Not supported</p>
						<p className="unsupported-formats">
							{unsupportedFormats.join( ', ' )}
						</p>
					</div>
				</div>
				<Button
					type="filled"
					color="primary"
					onClick={onConfirm}
				>
					Got it
				</Button>
			</div>
		</div>
	);
};

export default UnsupportedFileFormatsPopup;
